// extracted by css-extract-rspack-plugin
export default {"intro":"intro_O25Ufu","platformWrapper":"platformWrapper_xsUtKv","platform":"platform_OwOA7q"};